import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width||364}
    height={365}
    viewBox="0 0 364 365"
    fill="none"
    {...props}
  >
    <path
      stroke="url(#ams)"
      strokeLinecap="round"
      strokeWidth={2}
      d="M1.21 1 362.79 363"
    />
    <defs>
      <linearGradient
        id="ams"
        x1={1.105}
        x2={362.895}
        y1={1.105}
        y2={362.895}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DDCFA2" />
        <stop offset={0.095} stopColor="#8C866B" />
        <stop offset={0.24} stopColor="#8C866A" />
        <stop offset={0.475} stopColor="#F5E6B6" />
        <stop offset={0.62} stopColor="#8C866B" />
        <stop offset={0.86} stopColor="#8C866B" />
        <stop offset={1} stopColor="#A59A87" />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgComponent
